"use client";

import type { FC, Ref } from "react";
import { useTranslation } from "react-i18next";
import { AnalysisHeading } from "@huub-web/shared";

import type { AnalysisHeadingTemplateProps } from "../AnalysisHeadingTemplate";

export interface KeyConsiderationsHeadingTemplateProps
  extends AnalysisHeadingTemplateProps {}

/**
 * @deprecated 💀
 */
export const KeyConsiderationsHeadingTemplate: FC<
  KeyConsiderationsHeadingTemplateProps & { ref?: Ref<HTMLDivElement> }
> = ({ generatedAt, title, description, ref }) => {
  const { t } = useTranslation();

  return (
    <AnalysisHeading
      ref={ref}
      generatedAt={generatedAt}
      title={title ?? t("keyConsiderationsHeading.title")}
      description={description ?? t("keyConsiderationsHeading.description")}
    />
  );
};
